import { AfterContentInit, Directive, ElementRef, Input, InjectionToken, OnDestroy } from '@angular/core';
import { AppState, track } from '@cbcore/NGRX/core.state';
import { Store } from '@ngrx/store';
export const loadingButton: any = new InjectionToken('btnEl');

@Directive({
    selector: '[track]',
    standalone: true
})

export class TrackingDirective implements AfterContentInit, OnDestroy {
  @Input('track') trackingEvent: any;

  btnEl: HTMLElement;
  private clickListener?: (event: Event) => void;

  constructor(
    el: ElementRef,
    // private _trackingService: TrackingService
    private store: Store<AppState>
  ) {
    this.btnEl = el.nativeElement;
  }

  ngAfterContentInit(): void {
    try {
      if (this.btnEl) {
        this.clickListener = (trackingEvent) => {
          setTimeout(() => {
            this.trackEvent(trackingEvent);
          }, 1)
        };
        this.btnEl.addEventListener('click', this.clickListener);
      }
    } catch(e: any) { /* empty */ }
  }

  ngOnDestroy(): void {
    if (this.btnEl && this.clickListener) {
      this.btnEl.removeEventListener('click', this.clickListener);
    }
  }

  trackEvent(trackingEvent: any): void {
    if (!trackingEvent)
      return;

    const trackingObject = {
      'event': this.trackingEvent.event ? this.trackingEvent.event : 'micrositeEvent',
      'eventCategory': this.trackingEvent.eventCategory ? this.trackingEvent.eventCategory : null,
      'eventAction': this.trackingEvent.eventAction ? this.trackingEvent.eventAction : null,
      'eventLabel': this.trackingEvent.eventLabel ? this.trackingEvent.eventLabel : null,
      'eventValue': this.trackingEvent.eventValue ? this.trackingEvent.eventValue : null
    }

    if (this.trackingEvent.isTracking) {
      this.store.dispatch(track({event: trackingObject}));
    }
  }
}
